export default "__VITE_ASSET__CQ6g7UnN__"